var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.selectedModules),function(m){return _c('li',{key:m?.uid},[_vm._v(" "+_vm._s(m?.libelle)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }